export const TOKEN_ERRORS = {
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    INVALID_TOKEN: 'INVALID_TOKEN',
    USER_ALREADY_ACTIVATED: 'USER_ALREADY_ACTIVATED'
};
